<ion-content [fullscreen]="true" class="upsell-content" [scrollY]="true">
  <div class="upsell" [class.upsell--hasClose]="step === 'promo'">
    <!-- Promo: Continue CTA into the native HealthKit / Health Connect sheet; X dismisses without Not now. -->
    <div class="upsell__promo" *ngIf="step === 'promo'">
      <div class="upsell__hero">
        <div class="upsell__icon">
          <ion-icon name="heart"></ion-icon>
        </div>
        <p class="upsell__eyebrow">{{ upsellPrefix + '.eyebrow' | translate }}</p>
        <h1>{{ upsellPrefix + '.title' | translate }}</h1>
        <p class="upsell__subtitle">{{ upsellPrefix + '.subtitle' | translate }}</p>
      </div>

      <ul class="upsell__benefits">
        <li>
          <span class="upsell__benefitIcon"><ion-icon name="scale-outline"></ion-icon></span>
          <div>
            <strong>{{ upsellPrefix + '.benefitWeightTitle' | translate }}</strong>
            <p>{{ upsellPrefix + '.benefitWeightBody' | translate }}</p>
          </div>
        </li>
        <li>
          <span class="upsell__benefitIcon"><ion-icon name="moon-outline"></ion-icon></span>
          <div>
            <strong>{{ upsellPrefix + '.benefitSleepTitle' | translate }}</strong>
            <p>{{ upsellPrefix + '.benefitSleepBody' | translate }}</p>
          </div>
        </li>
        <li>
          <span class="upsell__benefitIcon"><ion-icon name="walk-outline"></ion-icon></span>
          <div>
            <strong>{{ upsellPrefix + '.benefitActivityTitle' | translate }}</strong>
            <p>{{ upsellPrefix + '.benefitActivityBody' | translate }}</p>
          </div>
        </li>
      </ul>

      <div class="upsell__actions">
        <ion-button expand="block" color="secondary" [disabled]="connecting" (click)="connect()">
          <ion-spinner *ngIf="connecting && step === 'promo'" name="crescent" slot="start"></ion-spinner>
          {{ upsellPrefix + '.continue' | translate }}
        </ion-button>
      </div>
    </div>

    <!-- Syncing / Done -->
    <div class="upsell__sync" *ngIf="step === 'syncing' || step === 'done'">
      <div class="upsell__syncHeader">
        <div class="upsell__icon upsell__icon--sm">
          <ion-icon name="sync-outline" *ngIf="step === 'syncing'"></ion-icon>
          <ion-icon name="checkmark" *ngIf="step === 'done'"></ion-icon>
        </div>
        <h2 *ngIf="step === 'syncing'">{{ upsellPrefix + '.syncingTitle' | translate }}</h2>
        <h2 *ngIf="step === 'done'">{{ upsellPrefix + '.syncedTitle' | translate }}</h2>
        <p>{{ upsellPrefix + '.syncingSubtitle' | translate }}</p>
      </div>

      <ul class="upsell__syncList">
        <li *ngFor="let item of syncSteps" [attr.data-status]="item.status">
          <div class="upsell__syncMeta">
            <span class="upsell__syncLabel">{{ metricLabelKey(item.key) | translate }}</span>
            <span class="upsell__syncDetail" *ngIf="item.detail">{{ item.detail }}</span>
            <span class="upsell__syncDetail" *ngIf="!item.detail && item.status === 'empty'">
              {{ 'pages.connectedApps.upsell.noData' | translate }}
            </span>
          </div>
          <div class="upsell__syncStatus">
            <ion-spinner *ngIf="item.status === 'syncing'" name="crescent"></ion-spinner>
            <ion-icon *ngIf="item.status === 'done'" name="checkmark-circle" color="success"></ion-icon>
            <ion-icon *ngIf="item.status === 'empty'" name="remove-circle-outline" color="medium"></ion-icon>
            <ion-icon *ngIf="item.status === 'error'" name="alert-circle" color="danger"></ion-icon>
            <span class="upsell__pendingDot" *ngIf="item.status === 'pending'"></span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</ion-content>

<button
  type="button"
  class="upsell__close"
  *ngIf="step === 'promo'"
  [disabled]="connecting"
  (click)="notNow()"
  [attr.aria-label]="upsellPrefix + '.notNow' | translate">
  <ion-icon name="close"></ion-icon>
</button>
